import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppLayout } from "./components/AppLayout";
import Login from "./pages/Login";
import OrderEntry from "./pages/OrderEntry";
import Orders from "./pages/Orders";
import Kiosk from "./pages/Kiosk";
import Management from "./pages/Management";
import AuditLog from "./pages/AuditLog";
import Dashboard from "./pages/Dashboard";

const withLayout = (el, page) => (
  <ProtectedRoute page={page}>
    <AppLayout>{el}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/kiosk" element={<ProtectedRoute page="kiosk"><Kiosk /></ProtectedRoute>} />
            <Route path="/" element={withLayout(<OrderEntry />, "order_entry")} />
            <Route path="/orders" element={withLayout(<Orders />, "orders")} />
            <Route path="/dashboard" element={
              <ProtectedRoute page="dashboard"><AppLayout><Dashboard /></AppLayout></ProtectedRoute>
            } />
            <Route path="/management" element={withLayout(<Management />, "management")} />
            <Route path="/audit" element={withLayout(<AuditLog />, "audit")} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
